/**
 * dat-gui JavaScript Controller Library
 * http://code.google.com/p/dat-gui
 *
 * Copyright 2011 Data Arts Team, Google Creative Lab
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */

import dat from './src/dat/index';

module.exports = dat;



/** WEBPACK FOOTER **
 ** ../index.js
 **/


/** WEBPACK FOOTER **
 ** webpack:///../index.js
 **/